export default "__VITE_ASSET__BPqFEc$o__"